import config from '../../config';

export default {
  url: `${config.api.baseURL}/accounts/:accountId/babies/`,
  options: {
    method: 'POST'
  },
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/babies/create.js